import * as types from './mutation-types'
import axios from 'axios'
import mensagens from '@/util/mensagens'

const tratarRotaApi = (url) => window._Vue.$contextManager.handleApiPrefix(url)

export const ActionObterPoliticaSeguranca = async ({ commit }) => {
  commit(types.SET_CARREGANDO_DADOS, { status: true, mensagem: mensagens.carregandoDadosEdicao })
  try {
    const url = tratarRotaApi('/politica-seguranca')
    const resposta = await axios.get(url)
    commit(types.SET_FLAGS, resposta.data.retorno.dados)
  } finally {
    commit(types.SET_CARREGANDO_DADOS, { status: false, mensagem: '' })
  }
}

export const ActionSalvarPoliticaSeguranca = async ({ commit }, politicaSeguranca) => {
  commit(types.SET_MANIPULANDO_DADOS, { status: true, mensagem: mensagens.salvandoDadosCadastro })
  try {
    const url = tratarRotaApi('/politica-seguranca')
    const resposta = await axios.put(url, politicaSeguranca)
    const { retorno } = resposta.data
    commit(types.SET_DADOS_RETORNO_CADASTRO, retorno)
    return retorno
  } finally {
    commit(types.SET_MANIPULANDO_DADOS, { status: false, mensagem: '' })
  }
}

export const ActionResetarDadosRetornoCadastro = ({ commit }) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  })
}
